import React from "react";
import I18n from 'i18n.js.erb'
import { formatLocalizedDate, isDefined } from "../../utils/utils";


// callback: valorizzato quando il cliente, invece di recedere, ha chiesto di essere ricontattato dal
// customer support (Figma 305:962). Stessa pagina del recesso registrato, cambiano la frase a effetto e
// il testo sotto, che ricorda giorno e fascia oraria della chiamata al posto del numero d'ordine
const SubmissionListWithdrawalSuccess = ({ orderNumber, confirmationDate, links, callback }) => {

  return (
    <div className="slx-outcome">
      <div className="slx-outcome__headings">
        <h1 className="slx-outcome__title">{I18n.t('js.submissionListWithdrawalPage.success.title')}</h1>
        <p className="slx-outcome__subtitle">{I18n.t('js.submissionListWithdrawalPage.success.subtitle')}</p>
      </div>

      <p className="slx-outcome__claim">
        {I18n.t(`js.submissionListWithdrawalPage.${callback ? 'callback.success' : 'success'}.claim`)}
      </p>

      {
        callback ?
          <div className="slx-outcome__order">
            <p className="slx-outcome__note">
              {I18n.t('js.submissionListWithdrawalPage.callback.success.note',
                      { day: formatLocalizedDate(callback.day), timeSlot: callback.timeSlot })}
            </p>
          </div>
        :
          <div className="slx-outcome__order">
            <p className="slx-outcome__note">{I18n.t('js.submissionListWithdrawalPage.success.followUp')}</p>
            <p className="slx-outcome__order-number">{orderNumber}</p>
            {isDefined(confirmationDate) &&
              <p className="slx-outcome__note">
                {I18n.t('js.submissionListWithdrawalPage.success.confirmedOn', { date: formatLocalizedDate(confirmationDate) })}
              </p>
            }
          </div>
      }

      {/* Stessi pulsanti in fondo alla conferma dell'ordine (SubmissionListConfirmationComponent.js): come lì
          ogni link resta inline dentro il suo contenitore, altrimenti l'altezza non sarebbe la stessa */}
      <div className="slx-outcome__actions">
        {
          [
            [links.account, 'goToAccount'],
            [links.orders, 'goToOrders'],
            [links.certificates, 'goToCertificates']
          ].map(([href, label]) =>
            <div key={label} className="slx-outcome__action">
              <a href={href} className="slx-outline-pill">
                {I18n.t(`js.submissionListWithdrawalPage.success.${label}`)}
              </a>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default SubmissionListWithdrawalSuccess;
